// src/pages/TransferEntry/components/TransferItemsTable.js
import React,{useEffect} from "react";
import { Table, Button, App } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormField,
  addTransferRow,
  deleteTransferRow,
  updateTransferRow
} from "../TransferEntrySlice";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import InputNumberField from "../../../components/Input/InputNumber";
import { fetchCurrentStock } from "../../Sales/salesThunks";
import { selectAuthInfo } from "../../Auth/authSelectors";

const TransferItemsTable = ({ itemsList }) => {
  const dispatch = useDispatch();
  const lookups = useSelector((state) => state.lookups);
  const { modal } = App.useApp();
  const authInfo = useSelector(selectAuthInfo);

  const { branchDetails } = useSelector((state) => state.transferEntry);
  useEffect(() => {
      if (!branchDetails) return;

      const margin = Number(branchDetails.margin) || 0;

      const updatedItems = itemsList.map((item) => {
        const baseRate = item.base_rate || 0;

        const newRate = +(baseRate + (baseRate * margin) / 100).toFixed(2);

        return {
          ...item,
          margin,
          rate: newRate,
        };
      });

      dispatch(
        setFormField({
          field: "itemsList",
          value: updatedItems,
        })
      );
    }, [branchDetails]);


  const columns = [
    {
      title: "Item",
      dataIndex: "product",
      render: (_, record) => (
        <SearchListAutoComplete
          entityType="item"
     optionsList={lookups.items
  .filter((i) => i.is_service !== 'yes')  
  .map((i) => ({
    sale_id: i.item_id,
    display_text: i.item_name,
    rate: i.margin_rate
      ? (i.margin_rate + 100) / 100 + i.purchase_rate
      : i.purchase_rate,
  }))
}
          placeholder="Item"
          showAddNew={false}
          value={
            record.item_id
              ? {
                  sale_id: record.item_id,
                  display_text: record.product,
                }
              : null
          }
          onSelect={(obj) => {
            // ✅ Check if this item already exists

              if (!obj) {
    dispatch(
      setFormField({
        field: "itemsList",
        value: itemsList.map((r) =>
          r.key === record.key
            ? {
                ...r,
                item_id: null,
                product: "",
                rate: 0,
                current_qty: 0,
              }
            : r
        ),
      })
    );
    return;
  }
            const exists = itemsList.some(
              (r) => r.item_id === obj?.sale_id && r?.key !== record?.key
            );

            if (exists) {
              // Show a warning
              window.alert("This item is already added!");
              return;
            }

            dispatch(
              setFormField({
                field: "itemsList",
                value: itemsList?.map((r) =>
                  r.key === record.key
                    ? {
                        ...r,
                        item_id: obj?.sale_id,
                        product: obj?.display_text,
                        // rate: obj?.rate || 0,
                      }
                    : r
                ),
              })
            );
dispatch(
  fetchCurrentStock({
    itemId: obj.sale_id,
    warehouseId: 0,
  })
).then((res) => {
  if (res?.payload) {
    const stockData = res.payload; // single object, no [0] needed

    const avgRate = parseFloat(stockData?.average_rate || 0);
    const conversion = parseFloat(stockData?.conversion || 1);
    const rateWithConversion = +(avgRate * conversion).toFixed(2);
    const baseRate = avgRate * conversion;

    const margin = Number(branchDetails?.margin || 0);
    const finalRate = +(baseRate + (baseRate * margin) / 100).toFixed(2);

    dispatch(
      updateTransferRow({
        key: record.key,
        data: {
          current_qty: stockData?.current_qty || 0,
          base_rate: baseRate,
          margin:margin,
          rate: finalRate,
        },
      })
    );
  }
});
          }}
        />
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      render: (_, record) => (
        <InputNumberField
          min={0}
          precision={1}
          step={0.5}
          value={record.quantity}
          placeholder="1"
          onClick={() => {
            if (record.quantity !== null) {
              dispatch(
                setFormField({
                  field: "itemsList",
                  value: itemsList.map((r) =>
                    r.key === record.key
                      ? { ...r, quantity: null }
                      : r
                  ),
                })
              );
            }
          }}
          onChange={(val) => {
            
            const isMinusSale = authInfo.is_minus_stock_sale;
            if (record?.current_qty < val && isMinusSale === "no") {
              modal.warning({
                title: `Insufficient quantity`,
                content: (
                  <>
                    <p>
                      Available Quantity Is:{" "}
                      <strong style={{ color: "red" }}>
                        {record.current_qty}
                      </strong>
                    </p>
                  </>
                ),
              });
            } else {
              dispatch(
                setFormField({
                  field: "itemsList",
                  value: itemsList.map((r) =>
                    r.key === record.key ? { ...r, quantity: val } : r
                  ),
                })
              );
            }
          }}
        />
      ),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      render: (_, record) => (
        <InputNumberField
          min={0}
          step={0.01}
          precision={2}
          value={record.rate}
          disabled
          onChange={(val) =>
            dispatch(
              setFormField({
                field: "itemsList",
                value: itemsList.map((r) =>
                  r.key === record.key ? { ...r, rate: val } : r
                ),
              })
            )
          }
        />
      ),
    },
    {
      title: "Margin %",
      dataIndex: "margin",
      render: (_, record) => (
        <span>{record.margin || 0}%</span>
      ),
    },
    {
      title: "Total",
      render: (_, record) => (
        <span>
          {parseFloat((record.quantity || 0) * (record.rate || 0)).toFixed(2)}
        </span>
      ),
    },
    {
      title: "",
      render: (_, record) => (
        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => dispatch(deleteTransferRow(record.key))}
        />
      ),
    },
  ];

  return (
    <div>
      <Table
        dataSource={itemsList}
        columns={columns}
        pagination={false}
        rowKey="key"
        scroll={{ x: "max-content" }}
      />
      <Button
        icon={<PlusOutlined />}
        onClick={() => dispatch(addTransferRow())}
        style={{ marginTop: 12 }}
      >
        Add Row
      </Button>
    </div>
  );
};

export default TransferItemsTable;
